import { render, staticRenderFns } from "./dp-field.vue?vue&type=template&id=f4345fe0"
import script from "./dp-field.vue?vue&type=script&lang=js"
export * from "./dp-field.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports